import { motion } from 'framer-motion';

interface RealityCheckMiniBoxProps {
  historicalRatio: number;
  currentRatio: number;
}

export const RealityCheckMiniBox = ({ 
  historicalRatio,
  currentRatio
}: RealityCheckMiniBoxProps) => {
  return (
    <div className="bg-[#8364FF] rounded-xl p-4 border-2 border-[#8364FF] shadow-[4px_4px_0px_0px_#9B86EA] relative">
      <div className="text-white/60 text-sm mb-3">Income to House Prices</div>
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="space-y-3"
      >
        <div className="text-sm text-white/80">
          1980 to 2024
        </div>

        <div className="flex items-baseline space-x-1 text-[#9BFFA9]">
          <span className="text-2xl font-black">{historicalRatio.toFixed(1)}x</span>
          <span className="text-lg">→</span>
          <span className="text-2xl font-black">{currentRatio.toFixed(1)}x</span>
        </div>

        <div className="text-sm text-white/80">
          of your income
        </div>
      </motion.div>
    </div>
  );
};
